<template>
    <span class="j-dictionary-text" v-if="type === 'text' && !dictionary">
      <template v-if="multiple">
        <template v-if="Array.isArray(value)" >{{ value.map(v => getDictionaryTextByKeyAndValue(code || api, v, options)).join(textSeparator) }}</template>
        <template v-else>{{ value && value.split(separator).map(v => getDictionaryTextByKeyAndValue(code || api, v, options)).join(textSeparator) }}</template>
      </template>
      <template v-else>{{getDictionaryTextByKeyAndValue(code || api, value, options)}}</template>
    </span>
    <span class="j-dictionary-text" v-else-if="type === 'text' && dictionary">
      <template v-if="multiple">
        <template v-if="Array.isArray(value)" >{{ value.map(v => getDictionaryTextByArrayAndValue(dictionary, v, props)).join(textSeparator) }}</template>
        <template v-else>{{ value && value.split(separator).map(v => getDictionaryTextByArrayAndValue(dictionary, v, props)).join(textSeparator) }}</template>
      </template>
      <template v-else>{{getDictionaryTextByArrayAndValue(dictionary, value, props)}}</template>
    </span>
    <el-select v-else-if="type === 'select'" :class="{ 'j-dictionary-select-read-only': readOnly }" ref="EL_SELECT_DOM" style="width: 100%;" v-model="select" :clearable="readOnly ? false : clearable" :filterable="filterable" v-bind="$attrs" v-on="$listeners" :multiple="multiple" @change="selectEvent" :disabled="readOnly ? true : disabled" @dblclick.native="readOnlyShowHandle">
        <template v-for="option in options">
            <el-option v-if="!(disableSelects.includes(String(option[props['key']])) && hideDisabled)" :key="option[props['key']]" :label="option[props['value']] || ''" :value="String(option[props['key']] || '')" :disabled="disableSelects.includes(String(option[props['key']])) || readOnly"/>
        </template>
    </el-select>
    <el-radio-group v-else-if="type === 'checkbox' && !multiple" :class="{ 'j-dictionary-select-read-only': readOnly }" v-model="select" v-bind="$attrs" v-on="$listeners" @change="selectEvent" :disabled="readOnly ? true : disabled">
        <template v-for="option in options">
            <el-radio v-if="!(disableSelects.includes(String(option[props['key']])) && hideDisabled)" :key="option[props['key']]" :label="String(option[props['key']] || '')" :disabled="disableSelects.includes(String(option[props['key']]))" >{{option[props['value']] || ''}}</el-radio>
        </template>
    </el-radio-group>
    <el-checkbox-group v-else-if="type === 'checkbox' && multiple" :class="{ 'j-dictionary-select-read-only': readOnly }" v-model="select" v-bind="$attrs" v-on="$listeners" @change="selectEvent" :disabled="readOnly ? true : disabled">
        <template v-for="option in options">
            <el-checkbox v-if="!(disableSelects.includes(String(option[props['key']])) && hideDisabled)" :key="option[props['key']]" :label="String(option[props['key']] || '')" :disabled="disableSelects.includes(String(option[props['key']]))">{{option[props['value']] || ''}}</el-checkbox>
        </template>
    </el-checkbox-group>
</template>

<script>
    import Vue from 'vue'
    import mixins from './mixins'
    export default {
        name: 'JDictionary',
        mixins: [mixins],
        props: {
            dictionary: {
                type: Array,
                default: null
            },
            clearable: {
                type: Boolean,
                default: true
            },
            filterable: {
                type: Boolean,
                default: true
            },
            api: {
                type: String,
                default: ''
            },
            type: { // ['text', 'select', 'checkbox']
                type: String,
                default: 'text'
            },
            code: {
                type: String
            },
            value: [String, Number, Array],
            multiple: { // 多选 不适用于 type=text时
                type: Boolean,
                default: false
            },
            disableSelects: {
                type: Array,
                default: () => []
            },
            hideDisabled: {
                type: Boolean,
                default: false
            },
            disabledCache: { // 禁用缓存
                type: Boolean,
                default: false
            },
            cacheUpdate: { // 协商缓存开关默认打开（到期自动更新缓存） 旧系统使用时需要置为false
                type: Boolean,
                default: true
            },
            readOnly: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            textSeparator: {
                // 文本模式多选值显示的文本分隔符
                type: String,
                default: ','
            },
            separator: { // 多选时多个选项分割值
                // 分隔符
                type: String,
                default: ','
            },
            valueType: { // String/Array 多选时返回类型
                type: String,
                default: 'String'
            }
        },
        data () {
            return {
                select: '',
                options: []
            }
        },
        created() {
            this.updateData()
            this.updateSelect(this.value)
        },
        methods: {
            updateSelect (value) {
              if (this.type === 'select' || this.type === 'checkbox') {
                if (this.multiple) {
                  if (Array.isArray(value)) this.select = value
                  else if (value) { this.select = value.split(this.separator) }
                  else this.select = []
                } else {
                  if (!value && value !== 0) this.select = ''
                  else this.select = String(value)
                }
              }
            },
            updateData () {
                if (this.dictionary) return (this.options = this.dictionary)
                if (this.hasDicStore()) return this.injectStore()
                console.warn(`JDictionary解析失败，未注册JDictionary Store`)
            },
            selectEvent (v) {
              if (this.multiple) {
                if (this.valueType === 'String') {
                  this.$emit('input', v.join(this.separator))
                } else {
                  this.$emit('input', v)
                }
              } else {
                this.$emit('input', v)
              }
            },
            async injectStore () {
                if (!this.code && !this.api) return console.warn(`JDictionary加载失败，缺少code参数或api参数`)
                if (!this.disabledCache && Vue.store.state.JDictionary.Dic[this.code || this.api]) {
                    this.options = Vue.store.state.JDictionary.Dic[this.code || this.api] || []
                } else {
                    const { dic } = await Vue.store.dispatch('JDictionary/getDictionaryByKey', { key: this.code || this.api, url: this.api, cacheUpdate: this.cacheUpdate, reload: this.disabledCache })
                    this.options = dic || []
                }
            },
            hasDicStore () {
                return Vue.store && Vue.store.state.JDictionary
            },
            readOnlyShowHandle () {
              if (!this.readOnly) return
              this.$nextTick(() => { this.$refs.EL_SELECT_DOM && (this.$refs.EL_SELECT_DOM.visible = !this.$refs.EL_SELECT_DOM.visible) })
            }
        },
        watch: {
            value (nv) { this.updateSelect(nv) },
            multiple () { this.updateSelect(this.value) },
            api () { this.updateData() },
            code () { this.updateData() },
            dictionary () { this.updateData() }
        }
    }
</script>

<style lang="scss">
  .j-dictionary-select-read-only {
    // 下拉框只读样式
    .el-input.is-disabled {
      .el-input__suffix {
        display: none;
      }
      .el-input__inner {
        background-color: inherit;
        cursor: text!important;
        color: inherit;
      }
    }

    .el-radio.is-disabled.is-checked {
      .el-radio__label {
        color: inherit;
        cursor: text;
        user-select: text;
      }
    }

    .el-checkbox.is-disabled.is-checked {
      .el-checkbox__label {
        color: inherit;
        cursor: text;
        user-select: text;
      }
    }
  }
</style>
